/**
 * api.js — Shared Axios instance for Eliture LMS
 *
 * - baseURL is /lms, so every call is relative: api.get('/goals') → GET /lms/goals
 * - Automatically attaches the stored JWT (Bearer token) to every request
 * - No more double /lms/lms prefix bugs
 */
import axios from 'axios';

export const API_BASE = import.meta.env.VITE_API_URL || '/lms';

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('eliture_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

/**
 * toArr — safely extract an array from any API response shape.
 * Handles: plain array, {data:[]}, {videos:[]}, {questions:[]},
 *          {users:[]}, {goals:[]}, {rows:[]}, {items:[]}
 */
export const toArr = (v) =>
  Array.isArray(v) ? v
  : Array.isArray(v?.data)      ? v.data
  : Array.isArray(v?.videos)    ? v.videos
  : Array.isArray(v?.questions) ? v.questions
  : Array.isArray(v?.users)     ? v.users
  : Array.isArray(v?.goals)     ? v.goals
  : Array.isArray(v?.rows)      ? v.rows
  : Array.isArray(v?.items)     ? v.items
  : [];

export default api;
